import isobject from 'isobject';

/*!
 * get-value <https://github.com/jonschlinkert/get-value>
 *
 * Copyright (c) 2014-2018, Jon Schlinkert.
 * Released under the MIT License.
 */


var getValue = function (target, path, options) {
  if (!isobject(options)) {
    options = {
      "default": options
    };
  }

  if (!isValidObject(target)) {
    return typeof options["default"] !== 'undefined' ? options["default"] : target;
  }

  if (typeof path === 'number') {
    path = String(path);
  }

  var isArray = Array.isArray(path);
  var isString = typeof path === 'string';
  var splitChar = options.separator || '.';
  var joinChar = options.joinChar || (typeof splitChar === 'string' ? splitChar : '.');

  if (!isString && !isArray) {
    return target;
  }

  if (isString && path in target) {
    return isValid(path, target, options) ? target[path] : options["default"];
  }

  var segs = isArray ? path : split(path, splitChar, options);
  var len = segs.length;
  var idx = 0;

  do {
    var prop = segs[idx];

    if (typeof prop === 'number') {
      prop = String(prop);
    }

    while (prop && prop.slice(-1) === '\\') {
      prop = join([prop.slice(0, -1), segs[++idx] || ''], joinChar, options);
    }

    if (prop in target) {
      if (!isValid(prop, target, options)) {
        return options["default"];
      }

      target = target[prop];
    } else {
      var hasProp = false;
      var n = idx + 1;

      while (n < len) {
        prop = join([prop, segs[n++]], joinChar, options);

        if (hasProp = prop in target) {
          if (!isValid(prop, target, options)) {
            return options["default"];
          }

          target = target[prop];
          idx = n - 1;
          break;
        }
      }

      if (!hasProp) {
        return options["default"];
      }
    }
  } while (++idx < len && isValidObject(target));

  if (idx === len) {
    return target;
  }

  return options["default"];
};

function join(segs, joinChar, options) {
  if (typeof options.join === 'function') {
    return options.join(segs);
  }

  return segs[0] + joinChar + segs[1];
}

function split(path, splitChar, options) {
  if (typeof options.split === 'function') {
    return options.split(path);
  }

  return path.split(splitChar);
}

function isValid(key, target, options) {
  if (typeof options.isValid === 'function') {
    return options.isValid(key, target);
  }

  return true;
}

function isValidObject(val) {
  return isobject(val) || Array.isArray(val) || typeof val === 'function';
}

export default getValue;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@d_hristov/get-value/dist/index.esm.js
// module id = 1852
// module chunks = 115